'use client'

import { useSearchParams } from 'next/navigation'
import React, { useEffect } from 'react'
import { atom, useSetRecoilState } from 'recoil'

import { createBrowser } from '@/serverActions/createBrowser'

export const browserIdState = atom({
  key: 'browserId',
  default: null,
})

export default function BrowserProvider() {
  const searchParams = useSearchParams()
  const setBrowserId = useSetRecoilState(browserIdState)
  useEffect(() => {
    createBrowser(searchParams.toString()).then((newBrowserId) => {
      setBrowserId(newBrowserId)
    })
  }, [])
  return <></>
}
